var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.basic ? 'ic-svg' : '',attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('use',{attrs:{"xlink:href":`#${_vm.name}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }